module.exports = __webpack_public_path__ + "static/media/CreativityAndResilience.72b9aab7.png";